module.exports = __webpack_public_path__ + "static/img/yf_05.dcc82fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yf/yf_05.jpg
// module id = gZeW
// module chunks = 1